import gql from 'graphql-tag'

import { AuthCheckTokenQuery } from '../../../types/api'

const checkToken = {
  query: gql`
    query AuthCheckToken($email: String!, $token: String!) {
      rdvCheckToken(email: $email, token: $token)
    }
  `,
  transformer: (response: AuthCheckTokenQuery) => {
    return response.rdvCheckToken
  },
}

export default checkToken
